import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sale-ure',
  templateUrl: './sale-ure.component.html',
  styleUrls: ['./sale-ure.component.css']
})
export class SaleUreComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
